import { apiAxios } from '@/helpers'

const initialState = () => {
  return {
    streamingCount: {},
    antmediaStatus: '-',
  }
}

const state = initialState()

const actions = {
  fetchActiveLiveStreamCount({ commit }) {
    return apiAxios
      .get('/antmedia/active-live-stream-count')
      .then(({ data }) => {
        let streamingCount
        if (data && data.data) streamingCount = data.data

        commit('setStreamingCount', streamingCount)
      })
      .catch(() => {
        commit('setStreamingCount')
      })
  },
  fetchAntmediaStatus({ commit }) {
    return apiAxios
      .get('/antmedia/status')
      .then(({ data }) => {
        let antmediaStatus
        if (data && data.data) antmediaStatus = data.data.status

        commit('setAntmediaStatus', antmediaStatus)
      })
      .catch(() => {
        commit('setAntmediaStatus')
      })
  },
}

const mutations = {
  setStreamingCount(state, streamingCount) {
    state.streamingCount = streamingCount || {}
  },
  setAntmediaStatus(state, antmediaStatus) {
    state.antmediaStatus = antmediaStatus || '-'
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  resetStreamingCount(state) {
    state.streamingCount = {}
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
